import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
interface Props extends SvgProps {
  height?: number;
}

const Hyphen = ({ height = 16, ...props }: Props) => (
  <Svg viewBox="0 0 17 16" width={(17 * height) / 16} height={height} fill="none" {...props}>
    <Path stroke="#090A0A" strokeLinecap="square" strokeWidth={1.5} d="M4.915 8.25h6.5" />
  </Svg>
);
export default Hyphen;
